/* eslint-disable react/no-array-index-key */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import { useUpdateEffect } from 'react-use';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Checkbox,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import SubUserAddForm from './SubUserAddForm';
import SubUserAvatar from './SubUserAvatar';
import SubUserGeoInputForm from './SubUserGeoInputForm';
import { getRobots } from '../../common/util';
import { setPiboGeo } from '../../pibo';

const SubUserRegisterCard = ({
  // edit,
  // read,
  bAdd,
  bDel,
  bUpdate,
  robotList,
  checked,
  id,
  serial,
  serialId,
  name,
  nickName,
  birthDate,
  img,
  uuid,
  tel,
  guardiansTel,
  gender,
  geo,
  index,
  itemError,
  onInfoChange,
  onCancel,
  onComplete,
  onSearch,
  // onResetSearch,
  // searchedRobot,
}) => {
  const [isPrepare, setIsPrepare] = useState(false);
  const [gTels, setGuardianTels] = useState(guardiansTel || []);
  const [guardianTel, setGuardianTel] = useState('');

  const onChangeGuardian = (e) => {
    const { value } = e.target;
    setGuardianTel(value.replace(/[^\d]/g, ''));
  };

  const onAddGuardian = () => {
    if (
      guardianTel &&
      (gTels.length === 0 || !gTels.find((v) => v === guardianTel))
    ) {
      setGuardianTel('');
      setGuardianTels([...gTels, guardianTel]);
    }
  };

  const onRemoveGuardian = (v) => () => {
    const filterArr = [...gTels].filter((val) => v !== val);
    setGuardianTels(filterArr);
  };

  useUpdateEffect(() => {
    onInfoChange({ idx: index, name: 'guardiansTel', value: gTels });
  }, [gTels]);

  const onChange = (e) => {
    let value;
    if (e.target.name === 'img') {
      value = e.target.files[0];
    } else if (e.target.name === 'tel') {
      value = e.target.value ? e.target.value.replace(/[^0-9]/g, '') : '';
      // eslint-disable-next-line no-param-reassign
      e.target.value = value;
    } else if (e.target.name === 'item-check') {
      value = id;
    } else {
      value = e.target.value;
    }
    onInfoChange({ idx: index, name: e.target.name, value });
  };

  const handleGeoChange = (value) => {
    onInfoChange({ idx: index, name: 'geo', value });
    setPiboGeo(value);
  };

  const onChangeSerial = (type, d) => {
    if (type === 'select') {
      onInfoChange({ idx: index, name: 'serial', value: d.serial });
      onInfoChange({ idx: index, name: 'serialId', value: d.id });
    } else {
      onInfoChange({ idx: index, name: 'serial', value: null, rId: d });
      onInfoChange({ idx: index, name: 'serialId', value: null });
    }
  };

  useEffect(() => {
    if (name && serial) setIsPrepare(true);
    else setIsPrepare(false);
  }, [name, serial]);

  return (
    <Card variant="outlined">
      {bAdd && (
        <CardActions
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Button
            varinat="outlined"
            size="small"
            sx={{ minWidth: 8 }}
            onClick={onCancel}
          >
            취소
          </Button>
          <Button
            varinat="outlined"
            color="secondary"
            size="small"
            onClick={onComplete}
            disabled={!isPrepare}
            sx={{ minWidth: 8 }}
          >
            완료
          </Button>
        </CardActions>
      )}
      <CardContent>
        <Grid container spacing={1}>
          {(bUpdate || bDel) && (
            <Grid item xs={12}>
              <Checkbox
                name="item-check"
                color="secondary"
                checked={checked}
                onChange={onChange}
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <Typography variant="subtitle2">사용자 사진</Typography>
            <Box
              display="flex"
              alignItems="center"
              gap={1}
              sx={{ mt: 1, mb: 1 }}
            >
              <SubUserAvatar img={img} uuid={uuid} />
              {!bDel && (
                <label htmlFor={`avatar_${index}`}>
                  <input
                    accept="image/*"
                    style={{ display: 'none' }}
                    id={`avatar_${index}`}
                    name="img"
                    type="file"
                    onChange={onChange}
                  />
                  <Button size="small" variant="contained" component="span">
                    사진 변경
                  </Button>
                </label>
              )}
            </Box>
            <Typography
              color="error"
              sx={{ fontSize: '0.6428571428571428rem' }}
            >
              {itemError && 'img' in itemError ? itemError.img : ''}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2">사용자 이름</Typography>
            <TextField
              {...{
                name: 'name',
                placeholder: '사용자 이름을 입력하세요.',
                pattern: /.{1,}$/g,
                helperText: !name && '최소 한글자는 입력해야 합니다.',
                size: 'small',
              }}
              disabled={bDel}
              // value={user}
              defaultValue={name}
              onChange={onChange}
              margin="dense"
              required
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2">사용자 닉네임</Typography>
            <TextField
              {...{
                name: 'nickName',
                placeholder: '사용자 닉네임을 입력하세요.',
                size: 'small',
              }}
              disabled={bDel}
              // value={nickName}
              defaultValue={nickName}
              onChange={onChange}
              margin="dense"
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2">생일</Typography>
            <TextField
              {...{
                type: 'date',
                name: 'birthDate',
                defaultValue: birthDate && birthDate.split('T')[0],
                onChange,
                disabled: bDel,
                margin: 'dense',
                size: 'small',
                fullWidth: true,
                helperText:
                  itemError && 'birthDate' in itemError
                    ? itemError.birthDate
                    : '',
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2">성별</Typography>
            <Select
              {...{
                name: 'gender',
                value: gender || 'unknown',
                onChange,
                size: 'small',
                margin: 'dense',
                fullWidth: true,
                disabled: bDel,
              }}
              sx={{
                mt: 1,
                mb: 0.5,
                '& .MuiSelect-select.MuiSelect-outlined': {
                  lineHeight: '1.4375em',
                  py: '9px',
                },
              }}
            >
              <MenuItem value="female">여성</MenuItem>
              <MenuItem value="male">남성</MenuItem>
              <MenuItem value="unknown">공개 안함</MenuItem>
            </Select>
          </Grid>
          {bUpdate && (
            <Grid item xs={12}>
              <SubUserGeoInputForm
                id="location_search"
                name="location_search"
                value={geo}
                onChange={handleGeoChange}
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <Typography variant="subtitle2">전화번호</Typography>
            <TextField
              {...{
                name: 'tel',
                placeholder: '사용자 전화번호를 입력하세요.',
                size: 'small',
                type: 'tel',
                disabled: bDel,
                defaultValue: tel,
                onChange,
                margin: 'dense',
                fullWidth: true,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2">보호자 전화번호</Typography>
            {gTels.map((v, i) => (
              <Stack direction="row" key={`guardiantel${index}${i}`}>
                <TextField
                  {...{
                    name: `gtel${i}`,
                    placeholder: '보호자 전화번호를 입력하세요.',
                    size: 'small',
                    type: 'tel',
                    defaultValue: v,
                    disabled: true,
                    margin: 'dense',
                    fullWidth: true,
                  }}
                />
                <IconButton
                  color="secondary"
                  aria-label="remove"
                  sx={{ width: '40px', height: '40px', mt: '8px' }}
                  onClick={onRemoveGuardian(v)}
                >
                  <RemoveIcon />
                </IconButton>
              </Stack>
            ))}
            {gTels.length < 3 && (
              <Stack direction="row">
                <TextField
                  {...{
                    name: `gtel${gTels.length}`,
                    placeholder: '보호자 전화번호를 입력하세요.',
                    size: 'small',
                    type: 'tel',
                    onChange: onChangeGuardian,
                    onBlur: onAddGuardian,
                    value: guardianTel,
                    margin: 'dense',
                    fullWidth: true,
                    error: gTels.find((v) => v === guardianTel),
                    helperText: gTels.find((v) => v === guardianTel)
                      ? '이미 등록된 전화번호 입니다.'
                      : '우측의 추가(+)버튼을 선택하여 추가 완료하세요.',
                  }}
                />
                <IconButton
                  color="secondary"
                  aria-label="add"
                  onClick={onAddGuardian}
                  sx={{ width: '40px', height: '40px', mt: '8px' }}
                >
                  <AddIcon />
                </IconButton>
              </Stack>
            )}
          </Grid>
          <Grid item xs={12}>
            <SubUserAddForm
              id={id}
              selected={serial ? [{ id: serialId, serial }] : []}
              readOnly={bDel}
              searchedRobot={robotList}
              onSearch={onSearch}
              onChangeSerial={onChangeSerial}
              mini={!bUpdate && getRobots().length < 6}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default SubUserRegisterCard;
